import { CrmGameConceptStatus, CrmGameConceptSubStatus } from "../../models/crmStatus";
import { GameConceptSellerDetails } from "../../models/gameConceptSellerDetails";
import { GameConceptPageScope } from "../scopes";
import { createOnboardingAsyncAction } from "./helpers/actionCreators";

export type GameConceptPageData = {
  accountType: "id" | "aaa";
  gameConceptId: string;
  formData: unknown;
  state: {
    id: string;
    status: CrmGameConceptStatus;
    subStatus: CrmGameConceptSubStatus;
    approvalStatusComments?: string;
    submittedDate?: Date;
    acceptedDate?: Date;
  } | null;
  isDraft: boolean;
  canEdit: boolean;
  canSubmit: boolean;
  isOnboardingApproved: boolean;
  tlaRecipientEmail: string;
  tlaSentDate?: string;
  tlaReceivedDate?: string;
  bigId?: string;
  canAddStoreId?: boolean;
  selections?: unknown;
};

export enum GameConceptPageActions {
  FETCH_START = "@gameConceptPage/FETCH_START",
  FETCH_COMPLETED = "@gameConceptPage/FETCH_COMPLETED",
  FETCH_ERROR = "@gameConceptPage/FETCH_ERROR",
  FETCH_SELLER_START = "@gameConceptPage/FETCH_SELLER_START",
  FETCH_SELLER_COMPLETED = "@gameConceptPage/FETCH_SELLER_COMPLETED",
  FETCH_SELLER_ERROR = "@gameConceptPage/FETCH_SELLER_ERROR",
  SAVE_START = "@gameConceptPage/SAVE_START",
  SAVE_COMPLETED = "@gameConceptPage/SAVE_COMPLETED",
  SAVE_ERROR = "@gameConceptPage/SAVE_ERROR",
  SUBMIT_START = "@gameConceptPage/SUBMIT_START",
  SUBMIT_COMPLETED = "@gameConceptPage/SUBMIT_COMPLETED",
  SUBMIT_ERROR = "@gameConceptPage/SUBMIT_ERROR",
  STORE_ID_START = "@gameConceptPage/STORE_ID_START",
  STORE_ID_COMPLETED = "@gameConceptPage/STORE_ID_COMPLETED",
  STORE_ID_ERROR = "@gameConceptPage/STORE_ID_ERROR",
}

export const gameConceptPageActions = {
  saveStoreId: createOnboardingAsyncAction(
    GameConceptPageScope,
    GameConceptPageActions.STORE_ID_START,
    (gameConceptId: string, bigId: string) => ({ gameConceptId, bigId }),
    GameConceptPageActions.STORE_ID_COMPLETED,
    (gameConceptId: string, bigId: string) => ({ gameConceptId, bigId }),
    GameConceptPageActions.STORE_ID_ERROR,
    (gameConceptId: string, error: Error) => ({ gameConceptId, error })
  ),
  fetchSellerDetails: createOnboardingAsyncAction(
    GameConceptPageScope,
    GameConceptPageActions.FETCH_SELLER_START,
    (gameConceptId: string) => ({ gameConceptId }),
    GameConceptPageActions.FETCH_SELLER_COMPLETED,
    (gameConceptId: string, sellerDetails: GameConceptSellerDetails) => ({
      gameConceptId,
      sellerDetails,
    }),
    GameConceptPageActions.FETCH_SELLER_ERROR,
    (gameConceptId: string, error: Error) => ({ gameConceptId, error })
  ),
  fetchGameConcept: createOnboardingAsyncAction(
    GameConceptPageScope,
    GameConceptPageActions.FETCH_START,
    (gameConceptId: string) => ({ gameConceptId }),
    GameConceptPageActions.FETCH_COMPLETED,
    (data: GameConceptPageData) => ({ data }),
    GameConceptPageActions.FETCH_ERROR,
    (error: Error) => ({ error })
  ),
  saveGameConcept: createOnboardingAsyncAction(
    GameConceptPageScope,
    GameConceptPageActions.SAVE_START,
    (
      gameConceptId: string,
      formId: string,
      subFormId: string,
      isDraft: boolean,
      formDataPayload?: Record<string, unknown>
    ) => ({
      gameConceptId,
      formId,
      subFormId,
      isDraft,
      formDataPayload,
    }),
    GameConceptPageActions.SAVE_COMPLETED,
    (data: unknown) => ({ data }),
    GameConceptPageActions.SAVE_ERROR,
    (error: Error) => ({ error })
  ),
  submitGameConcept: createOnboardingAsyncAction(
    GameConceptPageScope,
    GameConceptPageActions.SUBMIT_START,
    (gameConceptId: string, bigId: string) => ({ gameConceptId, bigId }),
    GameConceptPageActions.SUBMIT_COMPLETED,
    (data: unknown) => ({ data }),
    GameConceptPageActions.SUBMIT_ERROR,
    (error: Error) => ({ error })
  ),
};
